/**
 * The one site an account links to (owner, 2026-10-14: "з одного тікток акаунта не було на 2 різних
 * сайти"). Everyone sees it; the first post with a link sets it; only an admin changes it, and changing one
 * already set is said twice — the posts already out still point at the old one.
 */

import { useState } from 'react'

import type { MarketingAccount } from '../../api/types'
import { useT } from '../../i18n'
import { useApp } from '../../lib/context'
import { ConfirmDanger } from '../../ui/ConfirmDanger'

export function AccountSite({ account, onChanged }: { account: MarketingAccount; onChanged: () => void }) {
  const t = useT()
  const m = t.accountPage
  const { api, auth } = useApp()
  const [editing, setEditing] = useState(false)
  const [value, setValue] = useState(account.site ?? '')
  const [asking, setAsking] = useState(false)
  const [problem, setProblem] = useState<string | null>(null)

  const save = async (confirm: boolean) => {
    setProblem(null)
    try {
      await api.editAccount(account.account_id, { site: value.trim() || null, ...(confirm ? { confirm: true } : {}) })
      setEditing(false)
      setAsking(false)
      onChanged()
    } catch (e) {
      const detail = (e as { detail?: { detail?: { error?: string; hint?: string } } })?.detail?.detail
      if (detail?.error === 'confirm_site_change') setAsking(true)
      else setProblem(detail?.hint ?? (e instanceof Error ? e.message : String(e)))
    }
  }

  return (
    <span className="account-site tiny">
      <span className="dim">{m.site}:</span>{' '}
      {editing ? (
        <form className="row" style={{ display: 'inline-flex' }} onSubmit={(e) => { e.preventDefault(); void save(false) }}>
          <input value={value} onChange={(e) => setValue(e.target.value)} placeholder="manyplay.fun"
                 aria-label={m.site} maxLength={200} autoFocus />
          <button className="primary tiny" type="submit">{m.siteSave}</button>
          <button className="ghost tiny" type="button" onClick={() => setEditing(false)}>{m.siteCancel}</button>
        </form>
      ) : (
        <>
          {account.site ? <b className="mono" title={account.site_by ? m.siteBy(account.site_by) : undefined}>
            {account.site}</b> : <span className="dim">{m.siteNone}</span>}
          {auth.isAdmin && <button className="ghost tiny" onClick={() => { setValue(account.site ?? ''); setEditing(true) }}>
            {m.siteChange}</button>}
        </>
      )}
      {problem && <span className="bad-text"> {problem}</span>}
      {asking && (
        <ConfirmDanger title={m.site} confirmLabel={m.siteSave} holdSeconds={2}
                       onCancel={() => setAsking(false)} onConfirm={() => void save(true)}>
          <div>{m.siteConfirm(account.site ?? '', value.trim())}</div>
        </ConfirmDanger>
      )}
    </span>
  )
}
